import { Button, Input, notification, Select, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { InfoGenService } from '../Services/InfoGenService';
import { ExerciceDocService } from '../Services/ExerciceDocService';
import * as XLSX from 'xlsx';
import { ExportOutlined } from '@ant-design/icons';
const { Option } = Select;
const AdherentsGen = () => {
  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(getSelectedYear());
  const [pageSize, setPageSize] = useState(5)
  const exerciceDocService = new ExerciceDocService();
  const infosgenService = new InfoGenService();


  useEffect(() => {
    const fetchData = async () => {
      try {
        const yearsData = await exerciceDocService.getFactureExercicesDoc();
        setYears([...yearsData].sort((a, b) => b - a));

      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData1 = async () => {
      if (selectedYear) {
        setLoading(true);
        try {
          const partgen = await infosgenService.getAdhtGen(
            selectedYear
          );
          setData(partgen);
          setFilteredData(partgen);
        } catch (error) {
          notification.error({
            message: "Erreur lors de la récupération des données",
          });
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData1();
  }, [selectedYear]);
  function formatNumber(number) {
    return new Intl.NumberFormat("fr-FR").format(number);
  }
  const columns = [
    {
      title: "Code",
      dataIndex: "codeadht",
      key: "codeadht",
      ellipsis: true,
      width: "15px",
      align: "center",
      render: (text) => <strong>{text || " "}</strong>, // Remplacer null/undefined par une chaîne vide
      sorter: (a, b) => (String(a.codeadht) || "").localeCompare(String(b.codeadht) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Libellé",
      dataIndex: "intitule",
      key: "intitule",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "left" }}>{text || " "}</div>
      ),
      ellipsis: true,
      width: "35px",
      sorter: (a, b) => (String(a.intitule) || "").localeCompare(String(b.intitule) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Compte",
      dataIndex: "compte",
      key: "compte",
      ellipsis: true,
      align: "center",
      width: "20px",
      render: (text) => text || " ", // Remplacer null/undefined par une chaîne vide
      sorter: (a, b) => (String(a.compte) || "").localeCompare(String(b.compte) || ""),
      sortDirections: ["ascend", "descend"],
    },

    {
      title: "Solde Adhérent",
      dataIndex: "solde",
      key: "solde",
      ellipsis: true,
      align: "right",
      width: "20px",
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", paddingLeft: "15px", paddingRight: "15px" }}>
          <strong> {formatNumber(text || " ")}</strong>
        </div>
      ),
      sorter: (a, b) => (String(a.compte) || "").localeCompare(String(b.compte) || ""),
      sortDirections: ["ascend", "descend"],
    },

  ];
  const handleYearChange = (value) => {
    setSelectedYear(value);
  };
  const handleSearch = (value) => {
    const filtered = data.filter(item =>
      Object.keys(item).some(key =>
        String(item[key]).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData); // Convertit les données en feuille Excel
    const wb = XLSX.utils.book_new(); // Crée un nouveau classeur
    XLSX.utils.book_append_sheet(wb, ws, 'Détails Actes'); // Ajoute la feuille au classeur
    XLSX.writeFile(wb, 'details_actes.xlsx'); // Enregistre le fichier Excel
  };
  return (
    <div >
      <Space style={{ display: "flex", justifyContent: "space-between" }}>
        <Space wrap>
          <Space
            direction="vertical"
            style={{ marginRight: 12, textAlign: "left", padding: 2 }}
          >
            <label>Exercice</label>
            <Select
              bordered={false}
              style={{ borderBottom: "2px solid #030303", width: "100%" }}
              onChange={handleYearChange}
              value={selectedYear}
            >
              {years.map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>
          </Space>

          <Space style={{ marginTop: 25 }}>
            <Input
              placeholder="Recherche..."
              bordered={false}
              onChange={(e) => handleSearch(e.target.value)}
              onPressEnter={(e) => handleSearch(e.target.value)}
              style={{ borderBottom: "2px solid black", width: "100%" }}

            />
          </Space>
        </Space>
        <Button className='buttonExport' onClick={exportToExcel} style={{ marginTop: 25 }} icon={<ExportOutlined />}>Exporter</Button>
      </Space>




      <Table
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header1-table"
        showSorterTooltip={false}
        bordered
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
        scroll={{
          x: true,
        }}
     /* size='small' */ columns={columns}
        dataSource={filteredData}

        loading={loading}
      />
    </div>
  )
}

export default AdherentsGen